export default __webpack_public_path__ + "static/media/TheSimurghMountain-detail_by_vodanova.028539c1.mp4";